<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="associativaForm">
<form [formGroup]="associativaForm" (ngSubmit)="update();">
	<div class="row" *ngIf="inserimento && parte && parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cognome/Nome'"
			[valueInput]="parte.nominativo"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="parte.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Matricola'" [valueInput]="parte.matricola"></div>
		<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Codice fiscale'" [valueInput]="parte.codiceFiscale"></div>
	</div>
	<div class="row" *ngIf="inserimento && parte && parte.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Ragione sociale'"
			[valueInput]="parte.ragioneSociale"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Tipo persona'" [valueInput]="parte.tipoPersona?.label"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Partita iva'" [valueInput]="parte.partitaIva"></div>
	</div>
	<div class="row">

		<div comboModInput class="col-sm-4" [labelInput]="'Categoria'"
         formControlName="categoria"
         [control]="associativaForm.controls['categoria']"
         [optionsCombo] ="tipicategoriaOptions"
         [objectReference]="formControparte.categoria"
         [ngModel]="formControparte.categoria"
         (onReturn)="formControparte.categoria = $event"
         [mandatory]="false"></div>

		<!--<div datePickerInput [mandatory]="true"
			[control]="associativaForm.controls['dataAssociazione']"
			class="col-sm-4" [labelInput]="'Data associazione'" [dataAl]="formControparte.dataTermine"
			formControlName="dataAssociazione"
			[(ngModel)]="formControparte.dataAssociazione"></div>-->

		<div checkBoxRadio [submitPending]="!canCheckPrimary()"
			class="col-sm-4" [labelInput]="'Primaria'" [idInput]="inserimento ? 'primario-ins' : 'primario-mod'"
			formControlName="primario"
			[objectReference]="formControparte.primario"
			(onReturn)="formControparte.primario = $event"></div>
		<div checkBoxRadio class="col-sm-4"
			[idInput]="inserimento ? 'tipoSogg-ins' : 'tipoSogg-mod'"
        	[control]="associativaForm.controls['flagAttore']"
        	[ngModel]="formControparte.flagAttore"
			[labelNotChecked]="'Convenuto'"
			[labelChecked]= "'Attore'"
        	[labelInput]="'Tipo soggetto'"
        	formControlName="flagAttore" [objectReference]="formControparte.flagAttore"
        	(onReturn)="formControparte.flagAttore = $event;"></div>
			<!--<div checkBoxRadio class="col-sm-2" [labelInput]="'Cliente'"
      [idInput]="inserimento ? 'cliente-ins' : 'cliente-mod'" formControlName="cliente"
			[objectReference]="formControparte.cliente"
			[control]="associativaForm.controls['cliente']"
			(onReturn)="formControparte.cliente = $event"></div>-->
	</div>

	<div class="row">
		<div checkBoxRadio class="col-sm-4" [labelInput]="'Rinunciatario'"
      		[idInput]="inserimento ? 'ritirato-ins' : 'ritirato-mod'" formControlName="ritirato"
			[control]="associativaForm.controls['ritirato']"
			[objectReference]="formControparte.ritirato"
			(change)="formControparte.dataTermine=undefined;"
			(onReturn)="formControparte.ritirato = $event"></div>
		<div datePickerInput class="col-sm-4" [labelInput]="'Data rinuncia'"
			[submitPending]="!formControparte.ritirato"
			formControlName="dataTermine"
			[(ngModel)]="formControparte.dataTermine"
			[mandatory]="!!formControparte.ritirato">
		</div>
	</div>

	<div class="row">
		<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
			formControlName="note" [(ngModel)]="formControparte.note"></div>
	</div>
	<div class="row">
		<p class="mandatory col-sm-12">
			<em>* Campi obbligatori</em>
		</p>
	</div>
	<div class="row">
		<p class="col-sm-3 col-xs-6">
			<button type="button" class="btn btn-outline-secondary btn-block"
				(click)="createForm();">Reset</button>
		</p>
		<p submitButton [disabled]="!associativaForm.valid || (formControparte.ritirato && !formControparte.dataTermine)"
			class="col-sm-3 col-xs-6 col-sm-offset-6"
			[labelButton]="'Salva'">
			<!-- 				<button type="button" class="btn btn-primary btn-block" (click)="update();">Salva</button> -->
		</p>

	</div>
</form>
</ng-template>
